import { Department, sharedSchema } from "@shared-database/schema";
import { leoNotNullForeignID, timestampColumns } from "@shared-database/utils";
import type { InferInsertModel } from "drizzle-orm";
import { text } from "drizzle-orm/pg-core";

export const UserDepartment = sharedSchema.table("UserDepartment", {
  // Mixins
  ...timestampColumns,

  // Properties
  leoId: text("leoId").notNull(),
  departmentId: leoNotNullForeignID("departmentId").references(
    () => Department.id,
    { onDelete: "cascade" },
  ),
});

export type UserDepartmentInsertType = InferInsertModel<typeof UserDepartment>;
export type UserDepartmentBlueprint = Omit<
  UserDepartmentInsertType,
  "departmentId"
> & {
  departmentName: string;
  currentDepartmentLevel: number;
  parentDepartmentName: string;
  parentDepartmentLevel: number;
};
